var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDividerBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148.42,
    height: 82,
    viewBox: "0 0 148.42 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0 40.9999C94.3394 -51.2499 148.42 40.9999 148.42 40.9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43331 40.9999L0 40.9999C94.3394 -51.2499 148.42 40.9999 148.42 40.9999L147.248 40.9999Q147.108 40.7756 146.948 40.5265Q146.123 39.2399 145.097 37.7952Q141.806 33.1596 137.756 28.6995Q124.806 14.4379 109.173 7.31625Q87.3356 -2.63181 63.2197 3.05533Q33.2746 10.1171 1.43331 40.9999Z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0 0C94.3393 92.25 148.42 0 148.42 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.42 0C148.42 0 94.3393 92.25 0 0L1.4333 0Q33.2744 30.8828 63.2196 37.9447Q87.3353 43.6317 109.173 33.6837Q124.806 26.5621 137.756 12.3004Q143.944 5.48602 147.257 0L148.42 0Z",
    fill: "#000000",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerBlack);
export default __webpack_public_path__ + "static/media/dividerBlack.2bc130e0bb6573aeb9d7fae4f2de1a6d.svg";
export { ForwardRef as ReactComponent };